module.exports = __webpack_public_path__ + "86ae2e4e5cfe28d250e740cf27fbc592.svg";